/* eslint-disable */
import moment from 'moment';

export const notificationsHotel = [
    {
        id: '493190c9-5b61-4912-afe5-78c21f1044d7',
        icon: 'heroicons_solid:star',
        title: 'Revisión de proveedor',
        description: 'El proveedor X ha realizado su carga inicial.',
        time: moment().subtract(25, 'minutes').toISOString(), // 25 minutes ago
        read: false
    },
    {
        id: 'b91ccb58-b06c-413b-b389-87010e03a120',
        icon: 'heroicons_solid:mail',
        title: 'Proveedor nuevo',
        description: 'El proveedor Y ha finalizado su carga inicial',
        time: moment().subtract(3, 'hours').toISOString(), // 3 hours ago
        read: false,
        link: '/hotels/providers',
        useRouter: true
    }
];

export const notificationsProvider = [
    {
        id: '493190c9-5b61-4912-afe5-78c21f1044d7',
        icon: 'heroicons_solid:star',
        title: 'Rechazo inicial',
        description: 'El hotel A rechazó tu información inicial.',
        time: moment().subtract(25, 'minutes').toISOString(), // 25 minutes ago
        read: false,
        link: '/providers/hotels',
        useRouter: true
    },
    {
        id: '493190c9-5b61-4912-afe5-78c21f1044d7',
        icon: 'heroicons_solid:star',
        title: 'Rechazo de período',
        description: 'El hotel B rechazó tu información del período MM-YY.',
        time: moment().subtract(25, 'minutes').toISOString(), // 25 minutes ago
        read: false,
        link: '/providers/hotels',
        useRouter: true
    },
    {
        id: '30af917b-7a6a-45d1-822f-9e7ad7f8bf69',
        icon: 'heroicons_solid:refresh',
        title: 'Inicio de mes',
        description: 'Es primero y debes cargar tu información del período MM-YY',
        time: moment().subtract(4, 'day').toISOString(), // 4 days ago
        read: true,
    },
    {
        id: '30af917b-7a6a-45d1-822f-9e7ad7f8bf69',
        icon: 'heroicons_solid:refresh',
        title: 'Información faltante',
        description: 'Es 15 de mes y debes cargar tu información del período MM-YY',
        time: moment().subtract(4, 'day').toISOString(), // 4 days ago
        read: true,
    }, {
        id: '493190c9-5b61-4912-afe5-78c21f1044d7',
        icon: 'heroicons_solid:star',
        title: 'Aprobación',
        description: 'Tu información ha sido aprobada, sigue así.',
        time: moment().subtract(25, 'minutes').toISOString(), // 25 minutes ago
        read: false,
        link: '/providers/hotels',
        useRouter: true
    },
];
